// extracted by mini-css-extract-plugin
export default {"addJob":"addJobForm_addJob__Zi3rA","title":"addJobForm_title__Upzc5"};